const subAccountType = {
  OWN: 'PROPRIA',
  THIRD_PARTY: 'TERCEIRO'
};

module.exports = subAccountType;
